<template>
	<div>
		<v-card class="notes-page page pt-5" flat>
			<PageBlocked v-if="isBlocked" :blockRole="blockRole" />
			<v-card-text v-else-if="isBlocked !== null">
				<v-skeleton-loader
					style="max-width: 555px"
					v-bind="attrs"
					type="card"
					v-if="isLoading"
				/>
				<div v-else>
					<div class="notes-page__header">
						<button type="button" @click="createNote" class="notes-page__header__link">
							<Icon
								type="plus"
								color="var(--text_button_tint)"
								:size="24"
							/>
							Create Notes
						</button>
					</div>
					<NoteList v-if="notesList.length > 0" :resourcesItems="notes" />

					<div v-if="!isLoading && notesList.length <= 0" class="mt-5 align-center">
						<NewsFeedEmpty
							title="Notes is empty at the moment."
							description="Check back later."
						/>
					</div>
					<div
						class="d-flex mt-5 mb-2 ma-auto justify-center"
						v-if="!isLoading && notesList.length > 0"
					>
						<Pagination
							:page="filters.page"
							:pageCount="pageCount"
							v-on:pageChange="onPageChange"
						/>
					</div>
				</div>
			</v-card-text>
		</v-card>
	</div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import searchIcon from '@/assets/images/search.svg'
import NoteList from '@/components/Profile/NoteList.vue'
import NewsFeedEmpty from '@/components/Post/NewsFeedEmpty.vue'
import Pagination from '@/components/Pagination.vue'
import PageBlocked from '@/components/PageBlocked'
import Block from '@/mixins/Block.js'

export default {
	name: 'ProfileNotesPage',
	mixins: [Block],
	components: {
		NewsFeedEmpty,
		NoteList,
		Pagination,
		PageBlocked,
	},
	computed: {
		...mapGetters('profile', ['notes', 'notesMeta', 'isLoading']),
		...mapGetters('auth', ['profile']),
		...mapGetters('settings', ['appCore']),

		notesList() {
			if (this.notes.length <= 0) {
				return []
			}

			return this.notes
		},
		pageCount() {
			if (!this.notesMeta) {
				return 0
			}

			return +this.notesMeta.pageCount
		},
	},
	methods: {
		...mapActions('profile', ['getProfileNotes', 'clearNotes']),
		...mapActions('app', ['setPageTitle']),
		createNote() {
			this.$router.push({ name: 'profile-notes-add' })
		},

		onPageChange(page) {
			if (page !== this.filters.page) {
				const params = {
					search: this.filters.search,
					page: page,
				}
				this.filters.page = page
				const queryString = this.formatFilters(params)
				this.getNotes(queryString)
			}
		},
		getNotes(queryString) {
			this.getProfileNotes(queryString)
		},
		filterSearch(e) {
			clearTimeout(this.timer)

			const params = {
				search: e.target.value,
				page: 1,
			}
			this.filters.page = 1
			const queryString = this.formatFilters(params)

			this.timer = setTimeout(() => {
				this.getNotes(queryString)
			}, 500)
		},
		formatFilters(filters) {
			const { search, page } = filters

			let queryString = `page=${page}`

			if (search !== undefined && search.length > 0) {
				queryString += `&search=${search}`
			}

			return queryString
		},
	},
	data() {
		return {
			searchIcon,
			successMessage: false,
			errorMessage: false,
			resourceItem: null,
			attrs: {
				elevation: 0,
			},
			filters: {
				page: 1,
				search: '',
			},
			pageBlockedName: 'profile',
		}
	},
	created() {
		!this.isBlocked && !this.notes.length && this.getProfileNotes()
	},
	mounted() {
		this.setPageTitle('Notes')
	},
	beforeDestroy() {
		this.setPageTitle('')
		this.clearNotes()
	},
}
</script>

<style lang="scss">
.notes-page {
	max-width: 600px;
	width: 100%;
	border-radius: 10px !important;
	background-color: transparent !important;

	&__title {
		font-size: 24px;
		font-weight: 700;
		color: var(--accent-color);
		font-family: Montserrat, sans-serif;
	}

	&__header {
		display: flex;
		align-items: center;
		justify-content: flex-end;
		margin-bottom: 20px;
		&__link {
			display: flex;
			align-items: center;
			gap: 8px;
			font-family: 'Inter', sans-serif;
			font-weight: 700;
			font-size: 18px;
			line-height: 100%;
			letter-spacing: 0;
			text-align: center;
			color: var(--text_button_tint);
		}
	}
}
</style>
